
import React from "react";
import { Filter } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { 
  AlertTriangle, 
  Lightbulb, 
  HelpCircle, 
  MessageSquare 
} from "lucide-react";
import { FeedbackCategoryTag } from "@/types/feedback";

interface CategoryFilterProps {
  categoryFilter: FeedbackCategoryTag;
  setCategoryFilter: (category: FeedbackCategoryTag) => void;
  searchTerm: string;
  clearFilters: () => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categoryFilter,
  setCategoryFilter,
  searchTerm,
  clearFilters,
}) => {
  return (
    <div className="flex items-center gap-2">
      <Filter className="h-4 w-4 text-muted-foreground" />
      <Select
        value={categoryFilter || "all"}
        onValueChange={(val) => setCategoryFilter(val === "all" ? null : val as FeedbackCategoryTag)}
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="Filter op categorie" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Alle categorieën</SelectItem>
          <SelectItem value="bug">
            <div className="flex items-center gap-2">
              <AlertTriangle className="h-4 w-4" />
              <span>Bug</span>
            </div>
          </SelectItem>
          <SelectItem value="idee">
            <div className="flex items-center gap-2">
              <Lightbulb className="h-4 w-4" />
              <span>Idee</span>
            </div>
          </SelectItem>
          <SelectItem value="vraag">
            <div className="flex items-center gap-2">
              <HelpCircle className="h-4 w-4" />
              <span>Vraag</span>
            </div>
          </SelectItem>
          <SelectItem value="algemeen">
            <div className="flex items-center gap-2">
              <MessageSquare className="h-4 w-4" />
              <span>Algemeen</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
      
      {(searchTerm || categoryFilter) && (
        <Button
          variant="ghost"
          size="sm"
          onClick={clearFilters}
        >
          Wis filters
        </Button>
      )}
    </div>
  );
};

export default CategoryFilter;
